/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
import {
  ErrorResponse,
  ErrorResponseFromJSON,
  ErrorResponseFromJSONTyped,
  ErrorResponseToJSON,
  TopHealthcareProviders,
  TopHealthcareProvidersFromJSON,
  TopHealthcareProvidersFromJSONTyped,
  TopHealthcareProvidersToJSON,
} from "./";

/**
 *
 * @export
 * @interface TopHealthcareProvidersIEnumerableControllerResponse
 */
export interface TopHealthcareProvidersIEnumerableControllerResponse {
  /**
   *
   * @type {Array<TopHealthcareProviders>}
   * @memberof TopHealthcareProvidersIEnumerableControllerResponse
   */
  data?: Array<TopHealthcareProviders> | null;
  /**
   *
   * @type {ErrorResponse}
   * @memberof TopHealthcareProvidersIEnumerableControllerResponse
   */
  error?: ErrorResponse;
}

export function TopHealthcareProvidersIEnumerableControllerResponseFromJSON(
  json: any,
): TopHealthcareProvidersIEnumerableControllerResponse {
  return TopHealthcareProvidersIEnumerableControllerResponseFromJSONTyped(json, false);
}

export function TopHealthcareProvidersIEnumerableControllerResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): TopHealthcareProvidersIEnumerableControllerResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: !exists(json, "data")
      ? undefined
      : json["data"] === null
        ? null
        : (json["data"] as Array<any>).map(TopHealthcareProvidersFromJSON),
    error: !exists(json, "error") ? undefined : ErrorResponseFromJSON(json["error"]),
  };
}

export function TopHealthcareProvidersIEnumerableControllerResponseToJSON(
  value?: TopHealthcareProvidersIEnumerableControllerResponse | null,
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data:
      value.data === undefined
        ? undefined
        : value.data === null
          ? null
          : (value.data as Array<any>).map(TopHealthcareProvidersToJSON),
    error: ErrorResponseToJSON(value.error),
  };
}
